import { jsx, jsxs } from "react/jsx-runtime";
import { toolOutputToFeaturedProduct, sectionFadeInStyle } from "./utils.js";
import { FeaturedProductWidget } from "../FeaturedProductWidget.js";
import { CollapsibleProductSummary } from "./CollapsibleProductSummary.js";
function DataFeaturedProductPart({
  part,
  productMetadataMap,
  pdpStacklineSku
}) {
  const data = part.data;
  if (!data || !data.stacklineSku) return null;
  const product = (productMetadataMap == null ? void 0 : productMetadataMap.get(data.stacklineSku)) || toolOutputToFeaturedProduct(data);
  const isPdpContext = !!(pdpStacklineSku && data.stacklineSku === pdpStacklineSku);
  const content = /* @__PURE__ */ jsxs("div", { style: { animation: "concierge-fade-in 0.35s ease-out both" }, children: [
    /* @__PURE__ */ jsx("style", { dangerouslySetInnerHTML: { __html: sectionFadeInStyle } }),
    /* @__PURE__ */ jsx(FeaturedProductWidget, { product })
  ] });
  if (isPdpContext) {
    return /* @__PURE__ */ jsx(CollapsibleProductSummary, { product, defaultOpen: false, children: content });
  }
  return content;
}
export {
  DataFeaturedProductPart
};
//# sourceMappingURL=DataFeaturedProductPart.js.map
